// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2CBq_","range":"MonthRangeSwitch_range__1UP4N","disabled":"MonthRangeSwitch_disabled__3WR5J"};